import React from 'react'
import PickChamps from './components/PickChamps.jsx'
import Match from './components/Match.jsx'
import './assets/styles/components/App.scss'

const App = () => (
    <>
      <PickChamps />
      <Match />
    </>
)



export default App;
